// extracted by mini-css-extract-plugin
module.exports = {"editorHeader":"styles_editorHeader__3TfCp","editor":"styles_editor__3A14R"};